import type { PipelineGuardSimpleConditionType } from '@/gql/graphql';
import {
  getGuardHasBeen,
  getGuardHasNotBeen,
  getGuardMustBe,
  getGuardMustNotBe,
} from '@/helpers/pipelineGuardDescriptions';
import { useTranslation } from '@/i18n';

/**
 * Hook that provides functions to generate human-readable descriptions
 * for pipeline guard conditions.
 */
export const usePipelineGuardDescriptions = () => {
  const t = useTranslation();

  return {
    getMustBe: (type: PipelineGuardSimpleConditionType) =>
      getGuardMustBe(t, type),
    getMustNotBe: (type: PipelineGuardSimpleConditionType) =>
      getGuardMustNotBe(t, type),
    getHasBeen: (type: PipelineGuardSimpleConditionType) =>
      getGuardHasBeen(t, type),
    getHasNotBeen: (type: PipelineGuardSimpleConditionType) =>
      getGuardHasNotBeen(t, type),
  };
};
